<template>
  <div>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <v-card outlined flat tile color="#1B1B1B">
          <v-layout justify-center wrap pt-10 pb-10>
            <v-flex xs11 sm10 md8>
              <span class="aboutHead">About Us</span>
            </v-flex>
          </v-layout>
          <v-layout justify-center wrap pb-16>
            <v-flex xs12 sm10 md8>
              <v-layout justify-center wrap>
                <v-flex xs12 sm12 md7 pt-5>
                  <span class="aboutsubHead"
                    >DMAAC envisages modern <br />
                    enterprises and its vision.</span
                  >
                  <v-layout wrap pt-10>
                    <v-flex xs12 sm8 md8>
                      <v-layout justify-center wrap>
                        <v-flex xs2 sm2 md1 lg1>
                          <v-icon x-small color="#008FDB">mdi-rectangle</v-icon>
                        </v-flex>
                        <v-flex xs10 sm10 md11 lg11 text-left>
                          <span class="aboutText">
                            We project the futuristic vision of Smart
                            Enterprising.</span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm8 md8 pt-4>
                      <v-layout justify-center wrap>
                        <v-flex xs2 sm2 md1 lg1>
                          <v-icon x-small color="#008FDB">mdi-rectangle</v-icon>
                        </v-flex>
                        <v-flex xs10 sm10 md11 lg11 text-left>
                          <span class="aboutText">
                            Our focus is on Data Science and possibilities of
                            Machine Learning and Block Chain.</span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm8 md8 pt-4>
                      <v-layout justify-center wrap>
                        <v-flex xs2 sm2 md1 lg1>
                          <v-icon x-small color="#008FDB">mdi-rectangle</v-icon>
                        </v-flex>
                        <v-flex xs10 sm10 md11 lg11 text-left>
                          <span class="aboutText">
                            We believe and predicts that the way Enterprises
                            operates will experience a drastic shift from market
                            oriented to highly individual focused.</span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md5 text-right>
                  <v-img
                    contain
                    width="500px"
                    height="400px"
                    src="./../../assets/images/Group 9153.png"
                  >
                  </v-img>
                </v-flex>
                <v-flex
                  xs12
                  sm4
                  md4
                  pa-2
                  v-for="(list, index) in itemArray"
                  :key="index"
                  pt-10
                >
                  <v-img
                    contain
                    width="50px"
                    height="50px"
                    :src="list.image"
                  ></v-img>
                  <v-layout justify-start wrap pt-5>
                    <v-flex xs12>
                      <span class="titleAbout">{{ list.title }}</span>
                    </v-flex>
                    <v-flex xs10 pt-2>
                      <span class="textAbout"
                        >We project the futuristic vision of Smart Enterprising.
                        Our focus is on Data Science and possibilities of
                        Machine Learning and Block Chain.</span
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tab1: null,
      itemArray: [
        {
          image: require("./../../assets/images/003-pillar/003-pillar.png"),
          title: "History",
          text: "We project the futuristic vision of Smart Enterprising. Our focus is on Data Science and possibilities of Machine Learning and Block Chain.",
        },
        {
          image: require("./../../assets/images/004-achievement/004-achievement.png"),
          title: "Mission",
          text: "We project the futuristic vision of Smart Enterprising. Our focus is on Data Science and possibilities of Machine Learning and Block Chain.",
        },
        {
          image: require("./../../assets/images/002-leadership.png"),
          title: "Leadership",
          text: "We project the futuristic vision of Smart Enterprising. Our focus is on Data Science and possibilities of Machine Learning and Block Chain.",
        },
      ],
    };
  },
};
</script>
<style>
.titleAbout {
  color: #939393;
  font-family: ibmplexsanssemibold;
  font-size: 18px;
}
.textAbout {
  color: #ffffff;
  font-family: ibmplexsanssemibold;
  font-size: 14px;
}
</style>